import { difference } from 'lodash-es';

const diff = (array, values) => {
  return difference(array, values);
};

export default diff;
